import {QueuedCommand} from "../../entities/QueuedCommand";
import {PagingCtrl} from "../PagingCtrl";
import { StateParams, StateService } from "@uirouter/angularjs";
import {CmdCenterQueuedCmdModel} from "../../models/cmd/CmdCenterQueuedCmdModel";
import {NotificationService} from "../../services/NotificationService";

export class CmdCenterQueuedCmdCtrl extends PagingCtrl<QueuedCommand>{
    public static $inject = ['$scope','$location','$state','$stateParams','CmdCenterQueuedCmdModel','NotificationService'];
    test:string = "beep";
    dateOptions:any = {
        formatYear: 'yy',
        maxDate: new Date(2020, 5, 22),
        minDate: new Date(1979,1,1),
        startingDay: 1
    };
    dateOpened:boolean = false;
    beforeDate:any;
    constructor($scope:any,
                $location: ng.ILocationService,
                stateService:StateService,
                stateParamsService:StateParams,
                public model:CmdCenterQueuedCmdModel,
                public notifyService:NotificationService) {
        super($scope, $location, stateService, stateParamsService, model, notifyService);
        $scope.vm = this;
        this.$scope.$watch(()=>this.model.selectedCommandType,(newVal:any,oldVal:any)=>{
            this.getPaged();
        });
        this.$scope.$watch(()=>this.model.selectedCommandStatus,(newVal:any,oldVal:any)=>{
            this.getPaged();
        });
        this.$scope.$watch(()=>this.beforeDate,(newVal:any,oldVal:any)=>{
            if(this.beforeDate == null)
                this.model.before = "";
            else
                this.model.before = this.beforeDate.getFullYear() + "-" + (this.beforeDate.getMonth()+1) + "-" + this.beforeDate.getDate();
            this.getPaged();
        });
    }
    openDate(){
        this.dateOpened = true;
    }
    cancelCommands(){
        this.model.cancelCommands().then(()=>{
            this.getPaged();
        });
    }
    resendCommands(){
        this.model.resendCommands().then(()=>{
            this.getPaged();
        }).catch((exc)=>{
          this.notifyService.notifyError("Got error in resending commands:"+exc);
        });
    }
}
